import { useState } from 'react';
import { MailPlusIcon } from 'lucide-react';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { Button } from '@/components/ui/button';
import { useInvitations } from '@/hooks/useInvitations';
import { useIsAdmin } from '@/hooks/useAdmin';
import { SectionCard } from '../components/SectionCard';
import { InvitationTable } from '../features/InvitationTable';
import { InviteDialog } from '../features/InviteDialog';

const PAGE_SIZE = 15;

export function AdminInvitations() {
  useDocumentTitle('Admin - Invitations');
  const [page, setPage] = useState(0);
  const [isInviting, setIsInviting] = useState(false);
  const { data, isLoading } = useInvitations(page, PAGE_SIZE);
  const { isSuperAdmin } = useIsAdmin();

  return (
    <>
      <SectionCard
        title="Invitations"
        description="Self-registration is closed — accounts start here."
      >
        {isSuperAdmin && (
          <div className="mb-4 flex justify-end">
            <Button type="button" onClick={() => setIsInviting(true)}>
              <MailPlusIcon />
              Invite person
            </Button>
          </div>
        )}

        <InvitationTable
          invitations={data?.content ?? []}
          page={page}
          totalPages={data?.totalPages ?? 0}
          onPageChange={setPage}
          isLoading={isLoading}
        />
      </SectionCard>

      {isInviting ? <InviteDialog onClose={() => setIsInviting(false)} /> : null}
    </>
  );
}

export default AdminInvitations;
